import {roomInviteApi} from "@/core/api/room.invite.api";

export default {
  inviteRequestApi: async ({dispatch, commit, getters, rootGetters}, data) => {
    return await roomInviteApi.inviteByEmail(data);
  },
  checkInvitedEmail: async ({dispatch, commit, getters, rootGetters}, data) => {
    return await roomInviteApi.checkInvitedEmail(data);
  }
}